import React from 'react'

const AllOptions = () => (
    <React.Fragment>
        <option value=''>All</option>
        <option value='consultation_requested'>Consultation Requested</option>
        <option value='consultation_confirmed'>Consultation Confirmed</option>
        <option value='consultation_completed'>Consultation Completed</option>
        <option value='consultation_cancelled'>Consultation Cancelled</option>
        <option value='sessions_requested'>Sessions Requested</option>
        <option value='sessions_approved'>Sessions Approved</option>
        <option value='sessions_rejected'>Sessions Rejected</option>
        <option value='sessions_booked'>Sessions Booked</option>
        <option value='sessions_completed'>Sessions Completed</option>
        <option value='sessions_cancelled'>Sessions Cancelled</option>
    </React.Fragment>
)

const StatusFilter = ({ value, onChange }) => {

    const changeFilterType = (event) => {
        onChange(event.target.value === '' ? null : event.target.value)
    }

    return <select
        onChange={changeFilterType}
        style={{
            width: "100%",
            height: "40px",
            fontSize: "12px"
        }}
        value={value || ''}
    >
        <AllOptions />
    </select>
}

export default StatusFilter